module.exports = __webpack_public_path__ + "img/WeiBao.3098f808.png";